export const RSS_LINK = 'https://rss.acast.com/hey-fam'
export const PATREON_LINK = 'https://www.patreon.com/api/posts'
export const PATREON_REQUEST_PARAM_STRING =
  'include=audio.null&fields[user]=full_name,url&fields[post]=post_type,title,url,published_at&filter[is_draft]=false&filter[campaign_id]=822668&sort=-published_at&json-api-use-default-includes=false&json-api-version=1.0'

export const theme = {
  primary: {
    light: '#c1e4e8',
    main: '#9cd3da',
    dark: '#77c3cc'
  },
  secondary: {
    light: '#fffe88',
    main: '#FFFD55',
    dark: '#fffc22'
  }
}
